import React from 'react';
import {
	Box,
	Card,
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	Select,
	MenuItem,
	Typography,
} from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import { ParkingLocation } from 'containers/pages/CANpark/types/parkingLocation';

export const TaggingPolicySection: React.FC<{ loading: boolean }> = ({
	loading,
}) => {
	const { control, watch } = useFormContext<ParkingLocation>();
	const taggingPolicyType = watch('taggingPolicyType');

	return (
		<Card sx={{ padding: 1 }}>
			<Typography variant="body2" fontWeight={300}>
				Warning Policy
			</Typography>

			<FormControl fullWidth>
				<Controller
					control={control}
					name="taggingPolicyType"
					render={({ field }) => (
						<RadioGroup
							row
							{...field}
							sx={{ flexWrap: 'wrap', gap: 1 }}
						>
							<FormControlLabel
								value="never"
								control={<Radio />}
								label={
									<Typography variant="caption">
										Never
									</Typography>
								}
							/>
							<FormControlLabel
								value="afterXViolations"
								control={<Radio />}
								label={
									<Typography variant="caption">
										After X Violations
									</Typography>
								}
							/>
						</RadioGroup>
					)}
				/>
			</FormControl>

			{taggingPolicyType === 'afterXViolations' && (
				<Box display="flex" alignItems="center" gap={1} mt={1}>
					<Typography variant="body2" fontWeight={300}>
						Issue warning after every
					</Typography>
					<Controller
						control={control}
						name="taggingAfterViolations"
						render={({ field }) => (
							<Select
								{...field}
								variant="outlined"
								size="small"
								disabled={loading}
								sx={{ width: 170 }}
							>
								<MenuItem value={1}>violation</MenuItem>
								<MenuItem value={2}>2nd violation</MenuItem>
								<MenuItem value={3}>3rd violation</MenuItem>
								<MenuItem value={4}>4th violation</MenuItem>
								<MenuItem value={5}>5th violation</MenuItem>
							</Select>
						)}
					/>
				</Box>
			)}
		</Card>
	);
};
